/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Email_SupportInputs */

const en_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email support`)
};

const de_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Support`)
};

const fr_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support par e-mail`)
};

const es_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte por correo electrónico`)
};

const it_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto via email`)
};

const nl_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailsupport`)
};

const pl_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wsparcie e-mail`)
};

const fi_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköpostituen`)
};

const da_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailsupport`)
};

const sv_pricing_feature_email_support = /** @type {(inputs: Pricing_Feature_Email_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postsupport`)
};

/**
* | output |
* | --- |
* | "Email support" |
*
* @param {Pricing_Feature_Email_SupportInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_email_support = /** @type {((inputs?: Pricing_Feature_Email_SupportInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Email_SupportInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_email_support(inputs)
	if (locale === "fr") return fr_pricing_feature_email_support(inputs)
	if (locale === "es") return es_pricing_feature_email_support(inputs)
	if (locale === "it") return it_pricing_feature_email_support(inputs)
	if (locale === "nl") return nl_pricing_feature_email_support(inputs)
	if (locale === "pl") return pl_pricing_feature_email_support(inputs)
	if (locale === "fi") return fi_pricing_feature_email_support(inputs)
	if (locale === "da") return da_pricing_feature_email_support(inputs)
	if (locale === "sv") return sv_pricing_feature_email_support(inputs)
	return en_pricing_feature_email_support(inputs)
});